export const SOCIETE_LISTE_REQUETTE = "SOCIETE_LISTE_REQUETTE";
export const SOCIETE_LISTE_SUCCES = "SOCIETE_LISTE_SUCCES";
export const SOCIETE_LISTE_ECHEC = "SOCIETE_LISTE_ECHEC";

export const SOCIETE_ACTUELLE = "SOCIETE_ACTUELLE";

export const SOCIETE_CREATION_REQUETTE = "SOCIETE_CREATION_REQUETTE";
export const SOCIETE_CREATION_SUCCES = "SOCIETE_CREATION_SUCCES";
export const SOCIETE_CREATION_ECHEC = "SOCIETE_CREATION_ECHEC";

export const SOCIETE_UPDATE_REQUETTE = "SOCIETE_UPDATE_REQUETTE";
export const SOCIETE_UPDATE_SUCCES = "SOCIETE_UPDATE_SUCCES";
export const SOCIETE_UPDATE_ECHEC = "SOCIETE_UPDATE_ECHEC";

export const SOCIETE_DETAILS_REQUETTE = "SOCIETE_DETAILS_REQUETTE";
export const SOCIETE_DETAILS_SUCCES = "SOCIETE_DETAILS_SUCCES";
export const SOCIETE_DETAILS_ECHEC = "SOCIETE_DETAILS_ECHEC";
